import ch from './locales/ch.js';
import en from './locales/en.js';

export default {
  ch,
  en,
};



// WEBPACK FOOTER //
// ./src/i18n/messages.js